<template lang="pug">
  v-card
    v-card-title
      v-text-field(v-model='search' append-icon='search' label='Search' single-line='' hide-details='')
    v-data-table.elevation-1(:headers='headers' :items='questions' :search="search")
      template(v-slot:top)
        v-toolbar(flat='' color='white')
          v-toolbar-title Preguntas
          v-divider.mx-4(inset='' vertical='')
          .flex-grow-1
          v-dialog(v-model='dialog' max-width='800px')
            template(v-slot:activator='{ on }')
              v-btn.mb-2(color='primary' dark='' v-on='on') Nueva Pregunta
            v-window.elevation-1(v-model='window' :show-arrows='showArrows')
              v-window-item( key='0')
                v-card
                  v-card-title
                    v-col(cols='12' sm='12' md='12')
                      v-alert(v-model='msg.show' :dismissible='msg.diss' :type='msg.type')
                        | {{ msg.text }}
                    span.headline {{ formTitle }}
                  v-card-text
                    v-container
                      v-row
                        input(type='hidden' v-model='editedItem.id')
                        v-col(cols='12' sm='6' md='4')
                          v-text-field(v-model='editedItem.name' label='Nombre')
                        v-col(cols='12' sm='6' md='8')
                          v-text-field(v-model='editedItem.desc' label='Pregunta')
                        v-col(cols='12' sm='6' md='4')
                          v-select(:items='levels' ref='lvlSelect' item-text='name' item-value='id' v-model='editedItem.lvl_id' label='Nivel' @change='getCatsByLvl()')
                        v-col(cols='12' sm='6' md='4')
                          v-select(:items='categories' ref='catSelect' item-text='name' item-value='id' v-model='editedItem.cat_id' label='Categoría' @change='getSubcatsByCat()')
                        v-col(cols='12' sm='6' md='4')
                          v-select(:items='subcategories' ref='subcatSelect' item-text='name' item-value='id' v-model='editedItem.subcat_id' label='Subcategoría')
                        v-col(cols='12' sm='6' md='4')
                          v-select(:items='typesAns' ref='ansSelect' v-model='editedItem.ans_type' label='Tipo de Respuesta' @change='chekAnswer()')

              v-window-item( key='1')
                v-card
                  v-card-title
                    v-col(cols='12' sm='12' md='12')
                      v-alert(v-model='msg.show' :dismissible='msg.diss' :type='msg.type')
                        | {{ msg.text }}
                    span.headline Respuestas
                  v-card-text
                    v-container
                      v-row
                        v-col(cols='12' sm='6' md='8')
                          v-text-field(v-model='ansToAdd' label='Agregar respuesta' @keyup.enter='addAnswer()')
                        v-col(cols='12' sm='6' md='4')
                          v-btn.mx-2(fab='' dark='' small color='indigo' @click='addAnswer()')
                            v-icon(dark='') mdi-plus
                      v-row
                        v-col(cols='12' sm='10' md='10')
                          v-list-item-group(v-model='correct_answers' multiple='')
                            v-list-item(v-for='a in answers')
                              template(v-slot:default='{ active, toggle }')
                                v-list-item-action
                                  v-checkbox(v-model='active' color='primary' @click='toggle')
                                v-list-item-content
                                  v-col(cols='12' sm='6' md='2')
                                    v-icon(color='red' @click='removeAnswer(a)')  delete
                                  v-col(cols='12' sm='6' md='10')
                                    | {{ a }}
                        

                  v-card-actions
                    .flex-grow-1
                    v-btn(color='blue darken-1' text='' @click='close') Cancelar
                    v-btn(color='blue darken-1' text='' @click='save') Guardar
      template(v-slot:item.action='{ item }')
        v-icon.mr-2(small='' @click='editItem(item)')
          | editar

      template(v-slot:no-data='')
        v-btn(color='primary' @click='initialize') Reset

</template> 

<script>

  import { config } from '../config.js'

  export default {
    data: () => ({
      msg: {
        show: false,
        diss: true,
        type: 'success'
      },
      search:'',
      dialog: false,
      loading: false,
      settings: [],
      answers: [],
      correct_answers: [],
      ansToAdd: '',
      window: 0,
      showArrows: false,
      headers: [
        { text: 'Nombre', value: 'name', sortable: true },
        { text: 'Pregunta', value: 'desc', sortable: true },
        { text: 'Nivel', value: 'lvl', sortable: true },
        { text: 'Categoría', value: 'cat', sortable: true },
        { text: 'Subcategoría', value: 'subcat', sortable: true },
        { text: 'Tipo de Respuesta', value: 'ans_type_desc', sortable: false },
        
        { text: 'Acciones', value: 'action', sortable: false }

      ],
      typesAns: [
       { value: 1, text: 'Opción multiple' }, 
       { value: 2, text: 'Selección multiple' }, 
       { value: 3, text: 'Acompletar' }
      ],
      questions: [],
      levels: [],
      subcategories: [],
      categories: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        name: '',
        desc: '',
        cat_id: '',
        cat: '',
        subcat_id: '',
        subcat: '',
        lvl_id: '',
        lvl: '',
        ans_type: '',
        updateDate: ''
      },
      defaultItem: {
        id:'',
        name: '',
        desc: '',
        cat_id: '',
        cat: '',
        subcat_id: '',
        subcat: '',
        lvl_id: '',
        lvl: '',
        ans_type: '',
        updateDate: ''
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo registro' : 'Editar registro'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.$emit("loadingEvent", true);
      this.initialize()
    },

    methods: {
      initialize () {
        this.axios.get(`${config.serviceUri}questions`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.questions = response.data.payload.sort(function (a, b) {
                            if (a.lvl > b.lvl) {
                              return 1;
                            }
                            if (a.lvl < b.lvl) {
                              return -1;
                            }
                            return 0;
                          });
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.$emit("loadingEvent", false);
        });

        this.axios.get(`${config.serviceUri}catalogs?catalog=levels`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.levels = response.data.payload.sort(function (a, b) {
                            if (a.name > b.name) {
                              return 1;
                            }
                            if (a.name < b.name) {
                              return -1;
                            }
                            return 0;
                          });
            this.$emit("loadingEvent", false);
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.$emit("loadingEvent", false);
        });

      },

      getCatsByLvl(){
        this.$emit("loadingEvent", true);
        if(this.editedItem.lvl_id){
          this.axios.get(`${config.serviceUri}catalogs?catalog=categories&filter={"lvl_id":"${this.editedItem.lvl_id}"}`)
          .then( (response) => {
              console.log('Succes request: ',response.data);
              this.categories = response.data.payload;
              this.$emit("loadingEvent", false);
          })
          .catch( (error) => {
              console.log('Error: ', error);
              this.$emit("loadingEvent", false);
          });
        }        
      },

      getSubcatsByCat(){
        this.$emit("loadingEvent", true);
        if(this.editedItem.cat_id){
          this.axios.get(`${config.serviceUri}catalogs?catalog=subcategories&filter={"cat_id":"${this.editedItem.cat_id}"}`)
          .then( (response) => {
              console.log('Succes request: ',response.data);
              this.subcategories = response.data.payload;
              this.$emit("loadingEvent", false);
          })
          .catch( (error) => {
              console.log('Error: ', error);
              this.$emit("loadingEvent", false);
          });
        } 
      },

      editItem (item) {
        
        this.editedIndex = this.questions.indexOf(item)
        this.editedItem = Object.assign({}, item)

        this.answers = [];
        this.correct_answers = [];

        this.editedItem.answers.map( (a,i) => {
          this.answers.push(a.desc);
          if( a.correct ){
            this.correct_answers.push(i);
          }
        });

        this.getCatsByLvl();
        this.getSubcatsByCat();
        this.showArrows = true;


        this.dialog = true;
      },

      deleteItem (item) {
        const index = this.questions.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.questions.splice(index, 1)
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        this.$emit("loadingEvent", true);
        switch(this.editedItem.ans_type)
        {
          case 1: {
            console.log('Multiple Option');
            if(this.correct_answers.length === 1){

            }else{
              this.msg.show = true;
              this.msg.type = 'error';
              this.msg.text =  'Debe elegir solo una respuesta correcta';
            }
            break;
          }
          case 2: {
            console.log('Multiple Selection');
            if(this.correct_answers.length >= 1){

            }else{
              this.msg.show = true;
              this.msg.type = 'error';
              this.msg.text =  'Minimo debe elegir una respuesta correcta';
            }
            break;
          }
          case 3: {
            console.log('Complete');
            if(this.correct_answers.length >= 1){

            }else{
              this.msg.show = true;
              this.msg.type = 'error';
              this.msg.text =  'Minimo debe elegir una respuesta correcta';
            }
            break;
          }
        }

        let answersCol = [];

        this.answers.map( (a,i) => {
          let answer;
          answer = { index: i, text: a, correct: this.correct_answers.includes(i) ? true : false };
          answersCol.push(answer);
        });

        let question = this.editedItem;

        let _answers = [];

        this.answers.map( (a,i) => {
          let _ans = {};
          _ans.desc = a;
          _ans.correct = this.correct_answers.includes(i);
          _answers.push(_ans);
        })
          
        question.answers = _answers;
        if(question.lvl_id){
          question.lvl = this.$refs.lvlSelect.selectedItems[0].name;
        }else{
          this.msg.show = true;
          this.msg.type = 'error';
          this.msg.text =  'Debe seleccionar el nivel';
          return;
        }
        if(question.cat_id){
          question.cat = this.$refs.catSelect.selectedItems[0].name;
        }
        
        if(question.subcat_id){
          question.subcat = this.$refs.subcatSelect.selectedItems[0].name;  
        }
        question.ans_type_desc = this.typesAns.filter( t => t.value == question.ans_type)[0].text;

        if (this.editedIndex > -1) {

          console.log('Update item');
          Object.assign(this.questions[this.editedIndex], this.editedItem)

          console.log(`Question to update ${JSON.stringify(question)}`)
          debugger;

          this.axios.patch(`${config.serviceUri}questions?id=${question.id}`, question )
            .then( (response) => {
                console.log('Succes Updated: ',response.data);
                this.$emit("loadingEvent", false);
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.$emit("loadingEvent", false);
            });

        } else {
          console.log('New item');
          console.log(`Question to save ${JSON.stringify(question)}`)
          

          this.axios.post(`${config.serviceUri}questions`, question )
            .then( (response) => {
                console.log('Succes Creted: ',response.data);
                this.questions.push(question);
                this.correct_answers = [];
                this.answers = [];
                this.window = 0;
                
                this.$emit("loadingEvent", false);
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.$emit("loadingEvent", false);
            });
        }
        this.close()
      },

      chekAnswer () {
        if(this.editedItem.ans_type){
          this.showArrows = true;
        }
      },

      addAnswer() {
        if(this.ansToAdd){
          this.answers.push( this.ansToAdd );
          this.ansToAdd = '';
        }
      },

      removeAnswer(ans){
        let index = this.answers.indexOf(ans);
        this.answers.splice(index,1);
      },
    },
  }
</script>
